import { Button, DatePicker, Form } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'

const dateFormat = 'YYYY-MM-DD'
const monthFormat = 'YYYY-MM'
const DateFilterBlockV3 = ({
	typeDatePicker = 'date',
	value,
	onChange = () => {},
	handleGetData,
	handleResetFilter,
}) => {
	// useEffect(() => {
	// 	onChange({ startDate, endDate })
	// }, [startDate, endDate])

	const handeStartDateChange = (_, timeString) => {
		onChange({ fromDate: timeString })
	}

	const handeEndDateChange = (_, timeString) => {
		onChange({ toDate: timeString })
	}
	// console.log(moment(value.fromDate).format('YYYY-MM-DD'))
	// console.log(moment(value.toDate).format('YYYY-MM-DD'))
	// console.log(defaultValue)
	return (
		<div id="fee__time" className="fee__date-filter-block">
			<div className="fee__filter-field">
				<Form layout="vertical">
					<Form.Item
						label={typeDatePicker == 'date' ? 'Từ ngày' : 'Từ tháng'}
						style={{ width: '100%' }}
					>
						<DatePicker
							picker={typeDatePicker}
							getPopupContainer={() => document.getElementById('fee__time')}
							style={{ width: '100%' }}
							onChange={handeStartDateChange}
							// defaultValue={moment(startDate)}
							format={typeDatePicker == 'month' ? monthFormat : dateFormat}
							disabledDate={(current) => {
								return current && current >= moment(value.toDate).endOf('day')
							}}
							allowClear={false}
							value={value && moment(value.fromDate)}
						/>
					</Form.Item>
					<Form.Item
						label={typeDatePicker == 'date' ? 'Đến ngày' : 'Đến tháng'}
						style={{ width: '100%', marginTop: 8 }}
					>
						<DatePicker
							picker={typeDatePicker}
							getPopupContainer={() => document.getElementById('fee__time')}
							style={{ width: '100%' }}
							onChange={handeEndDateChange}
							// defaultValue={moment(endDate)}
							format={typeDatePicker == 'month' ? monthFormat : dateFormat}
							disabledDate={(current) => {
								return (
									moment().endOf('day') <= current ||
									current <= moment(value.fromDate).subtract(1, 'day').endOf('day')
								)
							}}
							allowClear={false}
							value={value && moment(value.toDate)}
						/>
					</Form.Item>
					<Form.Item label={''} style={{ width: '100%', marginTop: 8 }}>
						<Button onClick={() => handleResetFilter()}>Đặt lại bộ lọc</Button>
						<Button type="primary" onClick={() => handleGetData()}>
							Hoàn tất
						</Button>
					</Form.Item>
				</Form>
			</div>
		</div>
	)
}

export default DateFilterBlockV3
